import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import PropertyListing from "./components/PropertyListing";
import PropertyDetail from "./components/PropertyDetail";
import PropertyManagement from "./components/PropertyManagement";
import ServiceProviderManagement from "./components/ServiceProviderManagement";
import ServiceRequest from "./components/ServiceRequest";
import ServiceRequestDetail from "./components/ServiceRequestDetail";
import SubmitQuote from "./components/SubmitQuote";
import ListYourProperty from "./components/ListYourProperty";
import PropertySubmissions from "./components/PropertySubmissions";
import AdminServiceRequests from "./components/AdminServiceRequests";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider, RequireAdmin } from "./lib/auth";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/properties" element={<PropertyListing />} />
            <Route path="/properties/:id" element={<PropertyDetail />} />
            <Route path="/list-your-property" element={<ListYourProperty />} />
            <Route path="/service-request" element={<ServiceRequest />} />
            <Route path="/service-request/:id" element={<ServiceRequestDetail />} />
            <Route path="/submit-quote/:requestId/:providerId" element={<SubmitQuote />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/properties"
              element={
                <RequireAdmin>
                  <PropertyManagement />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/submissions"
              element={
                <RequireAdmin>
                  <PropertySubmissions />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/service-requests"
              element={
                <RequireAdmin>
                  <AdminServiceRequests />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/service-providers"
              element={
                <RequireAdmin>
                  <ServiceProviderManagement />
                </RequireAdmin>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
